import { html } from "lit";

const getImgHref = (image, image_type) => {
    return image.startsWith('data:') ? image : `data:${image_type};base64,${image}`;
}

const getImgHrefFromJID = (jid) => {
  return '/api/v1/conversejs/avatar/serve/' + jid;
}

export default  (o) => {
    if (o.jid) {
      return html`
        <img src="${getImgHrefFromJID(o.jid)}" width="${o.width}" height="${o.height}" class="reticular-avatar_img" onerror="this.style.visibility = 'hidden'" />
      `
    }

    if (o.image) {
        return html`
                <svg xmlns="http://www.w3.org/2000/svg" class="avatar ${o.classes}" width="${o.width}" height="${o.height}">
                    <image width="${o.width}" height="${o.height}" preserveAspectRatio="xMidYMid meet" href="${getImgHref(o.image, o.image_type)}"/>
                </svg>`;
    } else {
        return '';
    }
}
